import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Toggle from 'react-toggle';
import Select from 'react-select';
import DesignationGroupCertifications from './DesignationGroupCertifications';
import getLocale from '../../../i18n/getLocale';

class DesignationGroupTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.designation_id,
      aircraft_models_list: [],
      designation_groups: [],
      aircraft_model_id: null,
      exception: 0,
      name: null,
      type: null,
    };

    //bind específico
    this.addGroup = this.addGroup.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);

    // Handlers
    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({id: newProps.designation_id});
    if(Array.isArray(newProps.aircraft_models_list)) {
      this.setState({aircraft_models_list: newProps.aircraft_models_list});
    }
    if(Array.isArray(newProps.designation_groups)) {
      this.setState({designation_groups: newProps.designation_groups});
    }
  }

  addGroup(event) {
    event.preventDefault();
    var datasave = {
      designation_id: this.state.id,
      aircraft_model_id: this.state.aircraft_model_id,
      name: this.state.name,
      type: this.state.type,
      exception: this.state.exception,
    };
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao/grupo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteGroup (event) {
    var contract_requisition_group_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.deletarGrupo);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/designacao/requisicao/grupo/' + contract_requisition_group_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.loadData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }


  render() {
    var self = this;
    return (
        <div>
            <RequestApi ref={'request_api'} />
            <h3>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.tituloAdicionarNovoGrupo}</h3>
            <hr/>
            <form onSubmit={self.addGroup}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.Nome}:</label>
                    <input type="text" name='name' className="form-control" placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.placeholder.NomeDoGrupo} value={self.state.name} onChange={self.handleChange.bind(self, 'name')} required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.Tipo}:</label>
                    <Select
                      className="form-field-name"
                      name="type"
                      value={this.state.type}
                      searchable={true}
                      placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.placeholder.SelecioneTipo}
                      onChange={this.handleSelectChange.bind(this, 'type')}
                      options={[
                        {value: "E", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.opcoesTipo.E},
                        {value: "OU", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.opcoesTipo.OU},
                      ]}
                      required
                    />    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.Frota}:</label>
                    <Select
                        className="form-field-name"
                        name="aircraft_model_id"
                        value={this.state.aircraft_model_id}
                        searchable={true}
                        placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.placeholder.SelecionarFrota}
                        onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                        options={this.state.aircraft_models_list}
                    />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                    <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.Excecao}:</label>
                    <br/>
                    <Toggle
                        checked={this.state.exception}
                        aria-label='No label tag'
                        name="exception"
                        onChange={this.handleToggleChange.bind(this, 'exception')} />
                    </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosCertificados.formulario.botaoSalvarGrupo}</button>
            </form>
            {Object.keys(self.state.designation_groups).map(function(k) {
              return (
                <DesignationGroupCertifications handleAlert={self.props.handleAlert} loadData={self.props.loadData} RequestApi={self.refs.request_api} designation_id={self.state.designation_id}  designation_group_id={self.state.designation_groups[k].id} designation_group={self.state.designation_groups[k]} certifications_list={self.props.certifications_list} deleteGroup={self.deleteGroup} aircraft_models_list={self.state.aircraft_models_list} />
              );
            })}
        </div>
    );
  }
}

export default DesignationGroupTab;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationGroupTab.js